"use client";

import { ReactNode } from "react";
import { useMarquee } from "~/hooks/useMarquee";
import { cn } from "~/lib/utils";

type MarqueeProps = {
  children: ReactNode;
  speed?: number;
  direction?: "left" | "right";
  pauseOnHover?: boolean;
  allowDrag?: boolean;
  className?: string;
};

const Marquee = ({ children, speed, direction, pauseOnHover, allowDrag = false, className }: MarqueeProps) => {
    const { trackRef, hoverProps, dragProps } = useMarquee({
        speed,
        direction,
        pauseOnHover,
        allowDrag,
    });

    return (
        <div className={cn("relative w-full overflow-hidden", className)}>
            <div
                ref={trackRef}
                className="flex will-change-transform touch-pan-y"
                {...hoverProps}
                {...dragProps}
            >
                {children}
                <div className="contents" aria-hidden="true" inert>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Marquee;
